import { useEffect, useState } from "react";
import { Instagram } from "lucide-react";
import { TikTokIcon } from "@/components/Shared";

const WhatsAppGlyph = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="relative h-5 w-5" aria-hidden="true">
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2zm5.83 14.12c-.25.7-1.45 1.34-2.02 1.42-.52.08-1.17.11-1.89-.12-.44-.14-1-.32-1.71-.63-3.01-1.3-4.97-4.33-5.12-4.53-.15-.2-1.22-1.62-1.22-3.09 0-1.47.77-2.19 1.05-2.49.27-.3.6-.38.8-.38.2 0 .4.01.58.01.19 0 .44-.07.68.52.25.6.85 2.07.92 2.22.08.15.12.33.02.53-.1.2-.15.32-.3.5-.15.17-.31.39-.44.52-.15.15-.3.31-.13.61.17.3.76 1.26 1.64 2.04 1.13 1 2.08 1.32 2.37 1.47.3.15.47.12.65-.08.17-.2.75-.87.95-1.17.2-.3.4-.25.67-.15.27.1 1.72.81 2.02.96.3.15.5.22.57.35.08.12.08.72-.17 1.42z" />
  </svg>
);

const FLOATS = [
  {
    label: "WhatsApp us",
    href: "https://wa.me/message/GRQ25AXPDY2EI1",
    testid: "whatsapp-float-button",
    ping: true,
    Icon: WhatsAppGlyph,
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/btdesign.digital",
    testid: "instagram-float-button",
    ping: false,
    Icon: ({ className }) => <Instagram className={className} strokeWidth={1.9} />,
  },
  {
    label: "TikTok",
    href: "https://www.tiktok.com/@auvixtech",
    testid: "tiktok-float-button",
    ping: false,
    Icon: TikTokIcon,
  },
];

export default function WhatsAppFloat() {
  const [scrolledPast, setScrolledPast] = useState(false);

  useEffect(() => {
    const onScroll = () =>
      setScrolledPast(window.scrollY > window.innerHeight * 0.55);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-6 right-6 z-[70] flex flex-row items-center gap-3 transition-[opacity,transform] duration-500 ${
        scrolledPast
          ? "opacity-100"
          : "pointer-events-none translate-y-3 opacity-0 sm:pointer-events-auto sm:translate-y-0 sm:opacity-100"
      }`}
    >      {FLOATS.map(({ label, href, testid, ping, Icon }) => (
        <a
          key={testid}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={testid}
          aria-label={`${label} on ${label === "WhatsApp us" ? "WhatsApp" : label}`}
          className="group flex h-12 w-12 items-center justify-center gap-2.5 rounded-full bg-white text-sm font-medium text-ink shadow-[0_10px_30px_-6px_rgba(229,231,235,0.3)] transition-[transform,background-color] duration-300 hover:-translate-y-1 hover:bg-[#E5E7EB] sm:h-auto sm:w-auto sm:py-3 sm:pl-4 sm:pr-5"
        >
          <span className="relative flex h-5 w-5 items-center justify-center">
            {ping && (
              <span
                className="absolute inline-flex h-full w-full animate-ping rounded-full bg-black/15 opacity-60"
                aria-hidden="true"
              />
            )}
            <Icon className="relative h-5 w-5" />
          </span>
          <span className="hidden sm:inline">{label}</span>
        </a>
      ))}
    </div>
  );
}
